import { render } from "./ModalDefault.vue?vue&type=template&id=dd52035e&ts=true"
import script from "./ModalDefault.vue?vue&type=script&lang=ts"
export * from "./ModalDefault.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__